import React from 'react';
import { Reveal } from './Reveal';
import { stats } from '../data/stats';
export function StatsBar() {
  return <section aria-label="Numeri del pack" className="border-y border-brand-sand bg-brand-alt py-9" data-id="element-180" data-mp="1tbjghngupucr">
      <Reveal className="mx-auto grid max-w-content grid-cols-2 gap-y-8 px-4 text-center md:grid-cols-4 md:gap-8" data-id="element-181" data-mp="1oac9vrqg317o">
        {stats.map(([value, label], index) => <div key={label} className={`flex flex-col items-center justify-center ${index > 0 ? 'md:border-l md:border-brand-sand' : ''}`} data-id="element-182" data-mp="1ecz6xoxcvgae" data-mpi={index}>
            <span className="mb-1 font-display text-3xl font-extrabold tracking-tight text-brand-primary md:text-4xl" data-id="element-183" data-mp="19kei71tb3tdq">
              {value}
            </span>
            <span className="text-[10px] font-bold uppercase tracking-wider text-brand-gray md:text-xs" data-id="element-184" data-mp="10mvtnnggewx3">{label}</span>
          </div>)}
      </Reveal>
    </section>;
}